<ui-modal
  class="basket-modal"
  [isOpened]="true"
  modalTitle="Basket"
  (isOpenedChange)="closeModal()"
>
  <div class="basket">
    <div class="basket__table-info-group-container">
      <div class="basket__table-info-container">
        <form [formGroup]="basketGroup">
          <div #divToScroll class="table-container">
            <table class="table-container__options" ui-table>
              <thead>
                <tr>
                  <th class="currency-pair">Currency Pair</th>
                  <th class="weight">Weight</th>
                  <th class="power">Power</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="baskets">
                  <tr
                    tabindex="0"
                    *ngFor="let item of basketArray; let i = index"
                    [formGroupName]="i"
                    (click)="selectedBasketIndex = i"
                    [ngClass]="{
                      'selected-row': selectedBasketIndex === i
                    }"
                  >
                    <td>
                      <ng-select
                        [items]="cross"
                        [searchable]="true"
                        class="report-type"
                        formControlName="cross"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <input
                        type="text"
                        class="input-cell"
                        formControlName="weight"
                        [inputValidator]="['negativeInteger']"
                      />
                    </td>

                    <td>
                      <ng-select
                        [items]="basketDropdownOptions.power"
                        [searchable]="false"
                        class="report-type"
                        formControlName="power"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </form>
        <div class="bottom-table-add">
          <span class="add-text-container">
            <label class="Page-1">+</label>
            <label class="add-text" (click)="addNewBasket()"
              >Add Currency Pair</label
            >
          </span>
        </div>
      </div>

      <div class="basket__table-info-group-container__footer">
        <button
          class="
            ui-button ui-button__header ui-button--danger ui-button--delete
          "
          [disabled]="selectedBasketIndex === null"
          (click)="deleteBasket()"
        >
          Delete
        </button>
      </div>
    </div>

    <div class="basket__footer">
      <ng-container>
        <button
          class="ui-button primary"
          (click)="saveChanges()"
          [disabled]="!this.basketGroup.get('baskets').valid"
        >
          Save
        </button>
      </ng-container>
    </div>
  </div>
</ui-modal>
